/**
 * Created by alex.y on 9/14/2017.
 */
export class OrderSearch{
    public AgentId? : number = null;
    public Query: string;
    public CustomerID? : number = null;
}


// WEBPACK FOOTER //
// ./app/objects/responses/orderSearch.ts